// extracted by mini-css-extract-plugin
export default {"errorText":"ErrorMessage_errorText__-8kk0"};